const CommentIcon = () => {
  return (
    <svg
      id='comment_1_'
      data-name='comment (1)'
      xmlns='http://www.w3.org/2000/svg'
      width='17.983'
      height='18'
      viewBox='0 0 17.983 18'
    >
      <path
        id='Path_345'
        data-name='Path 345'
        d='M17.982,8.421A9,9,0,1,0,9,17.976h5.232a3.75,3.75,0,0,0,3.746-3.746Zm-1.5,5.809a2.248,2.248,0,0,1-2.248,2.248H9a7.523,7.523,0,0,1-5.6-2.5A7.43,7.43,0,0,1,1.547,8.118,7.525,7.525,0,0,1,8.032,1.554a7.915,7.915,0,0,1,.974-.061,7.433,7.433,0,0,1,4.779,1.723,7.523,7.523,0,0,1,2.7,5.276Z'
        transform='translate(0.001 0.024)'
        fill='#4c677b'
      />
      <path
        id='Path_346'
        data-name='Path 346'
        d='M7.749,8.5h3a.749.749,0,1,0,0-1.5h-3a.749.749,0,0,0,0,1.5Z'
        transform='translate(-1.754 -1.737)'
        fill='#4c677b'
      />
      <path
        id='Path_347'
        data-name='Path 347'
        d='M13.743,11H7.749a.749.749,0,1,0,0,1.5h5.994a.749.749,0,0,0,0-1.5Z'
        transform='translate(-1.754 -2.74)'
        fill='#4c677b'
      />
      <path
        id='Path_348'
        data-name='Path 348'
        d='M13.743,15H7.749a.749.749,0,1,0,0,1.5h5.994a.749.749,0,0,0,0-1.5Z'
        transform='translate(-1.754 -3.743)'
        fill='#4c677b'
      />
    </svg>
  );
};
export default CommentIcon;
